export default class printViewCtrl {
    constructor($scope, logger, httpRequest, $stateParams) {
        $('#wrapper').addClass('invoiceDetailPage')
        $scope.$on('$stateChangeStart', () => {
            $('#wrapper').removeClass('invoiceDetailPage')
        })

        $scope.waitIds = $stateParams.waitIds ? $stateParams.waitIds.split(',') : ''
        $scope.batchNo = $stateParams.batchNo

        // 批量打印-获取图片列表
        $scope.getImageList = function (waitIds) {
            httpRequest.post_qryQRCodeByBillNumbers(waitIds).then((res) => {
                $scope.qrCoderList = res.data.value
            }, (error) => {
                logger.logError(error)
            })
        }

        // 生成多张二维码 获取图片列表
        $scope.getImageListByBatchNo = function (batchNo) {
            const param = {
                pageNum: 1,
                pageSize: 50,
                param: batchNo,
            }
            httpRequest.post_qryQRCodeByBillNumberOfPage(param).then((res) => {
                $scope.qrCoderList = res.data.value.list
            }, (error) => {
                logger.logError(error)
            })
        }

        $scope.init = function () {
            $scope.qrCoderList = []
            if ($scope.waitIds) {
                $scope.getImageList($scope.waitIds)
            }
            if ($scope.batchNo) {
                $scope.getImageListByBatchNo($scope.batchNo)
            }
        }
        $scope.init()

        $scope.a4Print = function () {
            $('.print-title').hide()
            $('.scan-print-view').jqprint({
                importCSS: true, // true表示引进原来的页面的css，默认是true。（如果是true，先会找$("link[media=print]")，若没有会去找$("link")中的css文件）
                printContainer: true, // 表示如果原来选择的对象必须被纳入打印（注意：设置为false可能会打破你的CSS规则）。
                operaSupport: true,
            })
            $('.print-title').show()
        }
        $scope.rollPrint = function () {
            $('.print-title').hide()
            $('#preview-body').removeClass('print-body-wh100')
            $('#preview-body').removeClass('print-body')
            $('#preview-body').addClass('roll-body-wh25')
            $('#preview-body').addClass('roll-print-body')
            $('#preview-body').jqprint({
                importCSS: true,
                printContainer: true,
                operaSupport: true,
            })
            $('#preview-body').removeClass('roll-body-wh25')
            $('#preview-body').removeClass('roll-print-body')
            $('#preview-body').addClass('print-body-wh100')
            $('#preview-body').addClass('print-body')
            $('.print-title').show()
        }
    }
}
printViewCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$stateParams']



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/eleInvoice/printViewCtrl.js